import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Phone, Menu, X } from "lucide-react";
import { COMPANY } from "../../data/content";

const NAV = [
  { label: "Leistungen", href: "#leistungen" },
  { label: "Sorglos-Paket", href: "#sorglos" },
  { label: "Ablauf", href: "#ablauf" },
  { label: "Referenzen", href: "#referenzen" },
  { label: "Kontakt", href: "#kontakt" },
];

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const solid = scrolled || location.pathname !== "/";

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const goTo = (href) => {
    setOpen(false);
    if (location.pathname !== "/") {
      navigate("/" + href);
    } else {
      document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        solid
          ? "bg-white/90 backdrop-blur-md shadow-sm py-3"
          : "bg-transparent py-5"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8 flex items-center justify-between">
        <Link to="/" data-testid="header-logo" className="flex flex-col leading-none">
          <span
            className={`font-heading font-bold text-xl tracking-tight transition-colors ${
              solid ? "text-[#1F2933]" : "text-white"
            }`}
          >
            FLIESEN-GEFFKE
          </span>
          <span
            className={`text-[11px] uppercase tracking-[0.2em] transition-colors ${
              solid ? "text-[#B5651D]" : "text-[#C9B79C]"
            }`}
          >
            Meisterbetrieb Hamburg
          </span>
        </Link>

        <nav className="hidden lg:flex items-center gap-8">
          {NAV.map((item) => (
            <button
              key={item.href}
              data-testid={`nav-${item.href.slice(1)}`}
              onClick={() => goTo(item.href)}
              className={`text-sm font-semibold uppercase tracking-wide transition-colors hover:text-[#B5651D] ${
                solid ? "text-[#22282E]" : "text-white"
              }`}
            >
              {item.label}
            </button>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-4">
          <a
            href={COMPANY.phoneLink}
            data-testid="header-phone-link"
            className={`flex items-center gap-2 text-sm font-bold transition-colors hover:text-[#B5651D] ${
              solid ? "text-[#1F2933]" : "text-white"
            }`}
          >
            <Phone size={16} className="text-[#B5651D]" /> {COMPANY.phone}
          </a>
          <button
            data-testid="header-cta-button"
            onClick={() => goTo("#kontakt")}
            className="bg-[#B5651D] text-white px-5 py-2.5 text-xs uppercase tracking-wider font-semibold transition-all duration-300 hover:bg-[#9c5517] hover:-translate-y-0.5"
          >
            Angebot anfordern
          </button>
        </div>

        <button
          data-testid="mobile-menu-toggle"
          className={`lg:hidden p-2 ${solid ? "text-[#1F2933]" : "text-white"}`}
          onClick={() => setOpen(!open)}
          aria-label="Menü öffnen"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {open && (
        <div data-testid="mobile-menu" className="lg:hidden bg-white shadow-xl border-t border-[#E5E1D8]">
          <nav className="flex flex-col px-6 py-4">
            {NAV.map((item) => (
              <button
                key={item.href}
                onClick={() => goTo(item.href)}
                className="py-3 text-left text-sm font-semibold uppercase tracking-wide text-[#22282E] border-b border-[#E5E1D8] last:border-0"
              >
                {item.label}
              </button>
            ))}
            <a
              href={COMPANY.phoneLink}
              data-testid="mobile-phone-link"
              className="mt-3 btn-primary text-center"
            >
              <Phone size={16} /> Jetzt anrufen
            </a>
          </nav>
        </div>
      )}
    </header>
  );
};
